export default class Workplaces {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;

        this.slickSlides;
        this.gallery = this.element.querySelector(".workplaces__gallery");
        this.buttons = this.element.querySelector(".workplaces__buttons");
        this.loader = this.element.querySelector(".workplaces__loader");

        this.init();
    }

    init() {
        this.bindEvents();
    }
    bindEvents() {
        window.addEventListener("load", e => this.showGallery(e));
        $(document).ready(function() {
            $(".workplaces__gallery").on("init", function(event, slick) {
                $(".slick-slide").each(function(index, el) {
                    $(el).click(function(e) {
                        $(".slick-slider").slick(
                            "slickGoTo",
                            e.currentTarget.getAttribute("data-slick-index")
                        );
                    });
                });
                addCustomSlickAttributes();

                // Create a closure
                (function() {
                    // Your base, I'm in it!
                    var originalAddClassMethod = jQuery.fn.addClass;

                    jQuery.fn.addClass = function() {
                        // Execute the original method.
                        var result = originalAddClassMethod.apply(
                            this,
                            arguments
                        );

                        // trigger a custom event
                        if (arguments[0] == "slick-current") {
                            jQuery(this).trigger("cssClassChanged");
                        }

                        // return the original result

                        return result;
                    };
                })();

                // document ready function
                $(function() {
                    $(".slick-slide").bind("cssClassChanged", function(e) {
                        if ($(e.currentTarget).hasClass("slick-current")) {
                            $(".slick-slide").each(function(index, el) {
                                let children = $(el)
                                    .children()
                                    .children()
                                    .children();
                                $(children).each(function(index, el) {
                                    if (
                                        !children
                                            .parent()
                                            .parent()
                                            .parent()
                                            .hasClass("slick-current")
                                    ) {
                                        hideDetail(index, el);
                                    }
                                });
                            });

                            let children = $(e.currentTarget)
                                .children()
                                .children()
                                .children();
                            if (
                                children[2].classList.contains(
                                    "workplaces__detail--active"
                                )
                            )
                                return;
                            $(children).each(function(index, el) {
                                showDetail(index, el);
                            });
                        }
                    });
                });
            });

            $(".workplaces__gallery").slick({
                infinite: true,
                nextArrow: ".build__btn--next",
                prevArrow: ".build__btn--previous",
                rows: 1,
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                responsive: [
                    {
                        breakpoint: 1180,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 950,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 418,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            centerMode: false,
                            autoplay: true
                        }
                    }

                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
            function addCustomSlickAttributes() {
                // Iterate through each active slide and add our custom attribute
                $(".slick-slide").each(function(index, el) {
                    $(el).addClass("workplaces__slick-slide");
                });
            }
            function showDetail(index, el) {
                if (index == 1) {
                    let elementClass = $(el)
                        .attr("class")
                        .split(" ")[1];
                    $(el).addClass(elementClass + "--active");
                    $(el).animate({ bottom: "9.5rem" });
                } else if (index > 1) {
                    if ($(el).hasClass("workplaces__stripes")) {
                        $(el).animate({ opacity: 1 });
                    } else {
                        let elementClass = $(el).attr("class");
                        $(el).addClass(elementClass.trim() + "--active");
                        $(el).animate({ height: "11rem" });
                    }
                }
            }
        });
        function hideDetail(index, el) {
            if (index == 1) {
                let elementClass = $(el)
                    .attr("class")
                    .split(" ")[2];

                $(el).removeClass(elementClass);
                $(el).animate({ bottom: "-1rem" });
            } else if (index > 1) {
                if ($(el).hasClass("workplaces__stripes")) {
                    $(el).animate({ opacity: 0 });
                } else {
                    let elementClass = $(el)
                        .attr("class")
                        .split(" ")[1];
                    $(el).removeClass(elementClass);
                    $(el).animate({ height: "0" });
                }
            }
        }
    }

    showGallery() {
        this.gallery.classList.add("workplaces__gallery--loaded");
        this.buttons.classList.add("workplaces__buttons--loaded");
        this.loader.classList.remove("workplaces__loader--active");
    }
}
